<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actCatMain">
          <v-card id="actCatCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
            >{{ $t('nav.activityCategory') }}</v-card-title>
            <v-data-table
              id="actCatTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              :sort-by="['activityCategoryCode']"
              :sort-desc="[false]"
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td
                    style="text-align: right"
                  >{{ props.item.activityCategoryCode }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: left">{{ props.item.abbreviation }}</td>
                  <td
                    style="text-align: left"
                  >{{ props.item.activityType ? 1 : 0 }}</td>
                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">mdi-delete</v-icon>
                    </v-btn>&nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            class="form-control"
                            v-model="editedItem.activityCategoryCode"
                            :rules="[
                              () =>
                                !!editedItem.activityCategoryCode ||
                                requiredMessage
                            ]"
                            required
                            :readonly="editedIndex > -1"
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('nav.activityCategoryId') }} 
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            class="form-control"
                            v-model="editedItem.description"
                            :rules="[
                              () => !!editedItem.description || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('column.description') }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            class="form-control"
                            v-model="editedItem.abbreviation"
                            maxlength="10"
                          >
                            <template
                              v-slot:label
                            >{{ $t('column.abbreviation') }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            class="form-control"
                            :items="booleanOptions"
                            item-text="text"
                            item-value="value"
                            v-model="editedItem.activityType"
                          >
                            <template
                              v-slot:label
                            >{{ $t('activityCategory.type') }}</template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{
                    $t('common.cancel')
                    }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                  >{{ $t('common.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-btn
                id="btnAddactCat"
                color="primary"
                dark
                small
                left
                fab
                @click="createItem()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        showDialog: false,
        requiredMessage: this.$t("common.required"),
        headers: [
          {
            text: this.$t("nav.activityCategoryId"),
            align: "right",
            sortable: true,
            value: "activityCategoryCode",
            width: "15%",
          },
          {
            text: this.$t("column.description"),
            align: "left",
            value: "description",
          },
          {
            text: this.$t("column.abbreviation"),
            align: "left",
            value: "abbreviation",
          },
          {
            text: this.$t("activityCategory.type"),
            align: "left",
            value: "activityType",
          },
          {
            text: this.$t("column.actions"),
            align: "center",
            value: "actCatactions",
            sortable: false,
            width: "20%",
          },
        ],

        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        booleanOptions: [
          {
            text: "1",
            value: true,
          },
          {
            text: "0",
            value: false,
          },
        ],
      };
    },
    computed: {
      ...mapGetters([
        "m_actCat/getNextSeqCode",
        "m_actCat/getActivityCategories",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? this.$t("common.new") + " " + this.$t("nav.activityCategory")
          : this.$t("common.edit") + " " + this.$t("nav.activityCategory");
      },

      items() {
        return this["m_actCat/getActivityCategories"];
      },

      formIsValid() {
        return (
          this.editedItem.activityCategoryCode && this.editedItem.description
        );
      },
    },
    watch: {
      showDialog(val) {
        val || this.close();
      },
    },

    created() {
      this.refreshActivityCategories();
      this["m_actCat/fetchNextMaxCode"]();
    },

    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "m_actCat/createActivityCategory",
        "m_actCat/fetchNextMaxCode",
        "m_actCat/fetchActivityCategories",
        "m_actCat/updateActivityCategory",
        "m_actCat/deleteActivityCategory",
      ]),

      refreshActivityCategories() {
        this["m_actCat/fetchActivityCategories"]();
      },

      resetEntity(item) {
        this.editedIndex = item ? this.items.indexOf(item) : -1;
        this.editedItem = Object.assign({}, item || this.defaultItem);
      },

      editItem(item) {
        this.resetEntity(item);
        this.showDialog = true;
      },

      createItem() {
        this.resetEntity();
        this["m_actCat/fetchNextMaxCode"]();
        this.editedItem.activityCategoryCode = this["m_actCat/getNextSeqCode"];
        this.showDialog = true;
      },

      deleteItemConfirm(item) {
        this.resetEntity(item);

        var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";

        this.$confirm(this.$t(msg) + this.$t("nav.activityCategory") + "?", {
          buttonTrueText: this.$t("common.delete"),
          buttonFalseText: this.$t("common.cancel"),
          color: "warning",
          icon: "warning",
          title: this.$t("common.warning"),
          width: 350,
          property: "$confirm",
        }).then(
          (res) =>
            res &&
            this["m_actCat/deleteActivityCategory"](this.editedItem).then(
              this.refreshActivityCategories
            )
        );
      },
      close() {
        this.$refs.form.resetValidation();
        this.showDialog = false;
      },

      save() {
        if (~this.editedIndex) {
          this["m_actCat/updateActivityCategory"](this.editedItem).then(
            this.refreshActivityCategories
          );
        }

        if (!~this.editedIndex) {
          this["m_actCat/createActivityCategory"](this.editedItem).then(
            this.refreshActivityCategories
          );
        }

        this.close();
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
  };
</script>

<style>
  #actCatTable {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    height: auto;
  }
  #actCatTable header {
    font-weight: bold;
  }
  #actCatCard {
    width: auto;
  }
</style>